import { useQuery } from '@tanstack/react-query';
import { GET_USER_STATISTICS_QUERY } from '../../queries/user/userStatistics';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { UserStatisticsOutput } from '../../gql/graphql';

export const useUserStatistics = (input?: {
  from: string | null;
  to: string | null;
}) => {
  return useQuery<UserStatisticsOutput, Error>({
    queryKey: ['userStatistics', input],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getUserStatistics: UserStatisticsOutput },
        { from: string | null; to: string | null }
      >(GET_USER_STATISTICS_QUERY, {
        from: input?.from || null,
        to: input?.to || null,
      });
      return data.getUserStatistics;
    },
  });
};
